import { NavigateOptions, useNavigate, To } from 'react-router'

import { ROUTE_PATH } from 'lib/paths'
import { getI18nPath } from './helpers'

const useI18nNavigate = () => {
  const navigate = useNavigate()

  return (to: To | number, options?: NavigateOptions) => {
    if (typeof to !== 'number') {
      navigate(getI18nPath(to), options)
      return
    }

    // when navigate with step number from history stack, target path maybe not existed
    // force user to redirect to home if path still the same after navigate called
    const currentPath = window.location.href
    navigate(to)

    setTimeout(() => {
      const newPath = window.location.href
      if (currentPath === newPath) navigate(ROUTE_PATH.HOME)
    }, 100)
  }
}

export default useI18nNavigate
